import componentsBaseGrid from "/opt/build/repo/domains/core/config/app/components/base/grid"
import index from "/opt/build/repo/domains/core/config/app/index"
    
export default {...index,"components":{"base":{"grid":componentsBaseGrid}}}
